import { pxToRem } from "@mos-cat/ds-theme";
import { Cross } from "@mos-cat/ds-icons";
import type { DialogProps } from "reakit";
import { VisuallyHidden } from "reakit";
import type { BoxProps } from "../Box/Box";
import { Box } from "../Box/Box";
import { UtilityButton } from "../UtilityButton/UtilityButton";

type ModalCloseButtonProps = Pick<DialogProps, "hide"> & BoxProps;

export function ModalCloseButton({ hide, ...props }: ModalCloseButtonProps) {
  return (
    <Box
      mt={["modalCloseBtnMT", "modalBigCloseBtnMT"]}
      mr={["modalCloseBtnMR", "modalBigCloseBtnMR"]}
      position="absolute"
      right={0}
      top={0}
      styles={{
        label: "CLOSE",
      }}
      {...props}
    >
      <Box
        as={UtilityButton}
        onClick={hide}
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderRadius="modalClose"
        size={["modalCloseButtonSize", "modalBigCloseButtonSize"]}
        styles={{
          color: "modalCloseButtonColor",
          backgroundColor: "modalCloseButtonBg",
          borderColor: "modalCloseButtonBg",

          ":hover": {
            color: "modalCloseButtonColor",
            backgroundColor: "modalCloseButtonHoverBg",
            borderColor: "modalCloseButtonHoverBg",
          },
          ":active": {
            color: "modalCloseButtonColor",
            backgroundColor: "modalCloseButtonActiveBg",
            borderColor: "modalCloseButtonActiveBg",
          },
        }}
      >
        <Cross width={pxToRem(20)} height={pxToRem(20)} />
        <VisuallyHidden>Закрыть</VisuallyHidden>
      </Box>
    </Box>
  );
}
